module.exports = __webpack_public_path__ + "assets/images/covid-hits-home-15.jpg?v=88e7429e";